import { blutenProducts } from './data/bluten';
import { extrakteProducts } from './data/extrakte';
import { ICamProductOptions, ICamUnitOptions } from './data/shared';

export const CamProductList_EN: ICamProductOptions[] = [
    {
        label: "Flowers",
        options: [
            ...blutenProducts,
            { label: "Free text" }
        ]
    },
    {
        label: "Extracts",
        options: [
            ...extrakteProducts,
            { label: "Free text" }
        ]
    },
    {
        label: "Dronabinol",
        options: []
    },
    {
        label: "Sativex",
        options: []
    },
    {
        label: "Cesamet",
        options: []
    },
    {
        label: "Capsules",
        options: [
            { label: "Avextra Kapsel 2,5 mg THC / 2,5 mg CBD", thc_cbd: "2,5/2,5" },
            { label: "Avextra Kapsel 5 mg THC / 5 mg CBD", thc_cbd: "5/5" },
            { label: "Free text" }
        ]
    },
    {
        label: "Other",
        options: [{ label: "Free text" }]
    }
];

export const CamUnitList_EN: ICamUnitOptions[] = [
    {
        label: "Flowers",
        options: [
            "Milligram cannabis flowers (inhalative)",
            "Capsules cannabis flowers (inhalative)",
            "Milligram cannabis flowers (oral)",
            "Free text"
        ]
    },
    {
        label: "Extracts",
        options: [
            "Volume (in milliliter)",
            "Number of strokes (dosing pump)",
            "Number of drops (pipette)",
            "mg THC/CBD",
            "Free text"
        ]
    },
    {
        label: "Dronabinol",
        options: [
            "Volume (in milliliter)",
            "Number of strokes (dosing pump)",
            "Number of drops (pipette)",
            "mg THC",
            "Free text"
        ]
    },
    {
        label: "Sativex",
        options: ["Number of sprays", "Free text"]
    },
    {
        label: "Cesamet",
        options: ["Number of capsules", "Free text"]
    },
    {
        label: "Capsules",
        options: [
            "Number of capsules",
            "Milligram THC",
            "Milligram CBD",
            "Free text"
        ]
    },
    {
        label: "Other",
        options: [
            "Milligram THC",
            "Milligram CBD",
            "Free text"
        ]
    }
];
